import { useState } from 'react';
import { ContactForm } from '../../components/ContactForm';

export const AddNumber = () => {
  const [submitted, setSubmitted] = useState(false);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Add Number</h1>
        <p className="text-sm text-gray-600">Add a new contact directly to the phone book.</p>
      </div>
      {submitted ? (
        <div className="rounded-lg border border-green-200 bg-green-50 p-4 text-green-800">
          <p className="font-medium">Contact added successfully!</p>
          <p className="text-sm">The contact is now live in the phone book.</p>
          <button
            onClick={() => setSubmitted(false)}
            className="mt-3 rounded bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700"
          >
            Add another
          </button>
        </div>
      ) : (
        <ContactForm
          minimal
          onSuccess={() => setSubmitted(true)}
          onCancel={() => setSubmitted(false)}
        />
      )}
    </div>
  );
};
